import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { FeatureStateType } from "types/feature";

import { extraReducers } from "./feature.extraReducer";

const initialState: FeatureStateType = {
  isLoading: false,
  toggle: false,
};

const featureSlice = createSlice({
  name: "feature",
  initialState,
  reducers: {
    resetFeature: () => initialState,
  },
  extraReducers,
});

export const selectDataFeature = (state: ApplicationRootState) =>
  state.feature.toggle;
export const selectLoadingFeature = (state: ApplicationRootState) =>
  state.feature.isLoading;

export const { resetFeature } = featureSlice.actions;

export default featureSlice.reducer;
